<template>
  <section class="container">
    <section class="flexWrap row" v-for="(item,index) in newsList" :key="index">
      <section class="img"><img v-lazy="item.photo" :alt="item.title"></section>
      <section class="right">
        <a :href="item.newsUrl?ajaxUrl+item.newsUrl:`/news/detail/${item.id}`" target="_blank">
          <h3 class="ellipsis">{{item.title}}</h3>
        </a>
        <p class="ellipsis-2">{{item.content}}</p>
        <section class="flexWrap">
          <p>{{item.fabushijian}}</p>
          <a :href="item.newsUrl?ajaxUrl+item.newsUrl:`/news/detail/${item.id}`" target="_blank">
            <p>了解详情</p><i class="el-icon-arrow-right icon-arrow"></i>
          </a>
        </section>
      </section>
    </section>
    <el-pagination class="fenye" background @current-change="handleCurrentChange" :current-page="pageData.pageNum" :page-size="pageData.pageSize" layout="total, prev, pager, next, jumper"
      :total="pageData.total"></el-pagination>
  </section>
</template>

<script>
import { wllib } from '../../utils/index'
export default {
  components: {},
  name: 'newsIndustry',
  data() {
    return {
      ajaxUrl: Config.ajaxUrl,
      newsList: [
      ],
      pageData: {
        pageNum: 1,
        pageSize: 5,
        total: 0
      },
    }
  },
  methods: {
    loadData() {
      let { pageNum, pageSize } = this.pageData
      let req = {
        newsType: '行业新闻',
        isShow: true,
        pageNum: pageNum,
        pageSize: pageSize
      }
      wllib.net.wlGet(Config.ajaxUrl + "/news/list", req).then((res) => {
        let { rows, total } = res.data
        this.pageData.total = total
        this.newsList = rows
        this.newsList.forEach((item) => {
          item.fabushijian = wllib.utils.dateFormat(item.publicityTime)
          item.content = item.content.replace(/<.*?>|&nbsp;/ig, "")
          item.photo = this.getRealPicUrl(item.photo)
        });
      })
    },
    getRealPicUrl(url){
      return wllib.utils.getRealPicUrl(url)
    },
    handleCurrentChange(val) {
      this.pageData.pageNum = val
      this.scrollTop()
      this.loadData()
    },
    scrollTop() {
      window.scrollTo({
        top: 540,
        left: 0,
      })
    },
  },
  created() {
    this.loadData()
  }
}
</script>

<style lang='scss' scoped>
p {
  font-size: 18px;
  color: #8e8e8e;
  line-height: 28px;
  padding-top: 15px;
  overflow: hidden;
  height: 70px;
}
h3 {
  font-weight: 500;
  line-height: 22px;
  font-size: 22px;
  color: #262626;
}
a {
  &:hover {
    p {
      color: #308dff;
    }
    h3 {
      color: #308dff;
    }
  }
}
.icon-arrow {
  font-size: 14px;
  padding-bottom: 3px;
  margin-left: 8px;
  font-weight: 600;
  vertical-align: middle;
}
.container {
  padding-top: 60px;
  padding-bottom: 136px;
  .row {
    padding-top: 46px;
    padding-bottom: 49px;
    border-bottom: 1px solid #dce5ec;
    .img {
      width: 330px;
    }
    .right {
      width: 898px;
      text-align: left;
      .flexWrap {
        padding-top: 29px;
        p {
          padding-top: 0;
          line-height: 18px;
        }
      }
    }
    a {
      color: #8e8e8e;
      p {
        display: inline;
      }
      &:hover {
        color: #308dff;
      }
    }
  }
}
.fenye {
  padding-top: 65px;
}
</style>
